'use client';
import styled from 'styled-components';

export const StyledConfirmationHero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(0, 4)};
  background-color: ${props => props.theme.colors.background.base};

  @media ${({ theme }) => theme.tablet} {
    padding: ${({ theme }) => theme.spacing(8, 0)};
  }
`;

export const AvatarsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const Avatar = styled.div`
  margin-right: ${({ theme }) => theme.spacing(4)};
  &:last-of-type {
    margin-right: 0;
  }
`;

export const Header = styled.h1`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  ${({ theme }) => theme.fontFamily.base};
  ${({ theme }) => theme.typography.heading3};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
`;

export const Subheader = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing(6)};
  ${({ theme }) => theme.fontFamily.base};
  ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  text-align: center;
`;

export const Date = styled.p`
  display: inline-flex;
  font-weight: bold;
`;
